export enum eMyPurchasesPageTab {
	PURCHASES,
	QUESTIONS,
	FAVORITES
}
export enum eMyPurchasesPageTabString {
	PURCHASES = "compras",
	QUESTIONS = "preguntas",
	FAVORITES = "favoritos"
}

export function MyPurchasesPageTab_stringToNumber(tabString:string|null) : eMyPurchasesPageTab|undefined {
	switch (tabString) {
		case eMyPurchasesPageTabString.PURCHASES : {
			return eMyPurchasesPageTab.PURCHASES;
		}
		case eMyPurchasesPageTabString.QUESTIONS : {
			return eMyPurchasesPageTab.QUESTIONS;
		}
		case eMyPurchasesPageTabString.FAVORITES : {
			return eMyPurchasesPageTab.FAVORITES;
		}
		default : {
			return undefined;
		}
	}
}

export function MyPurchasesPageTab_numberToString(tabNumber:eMyPurchasesPageTab) : eMyPurchasesPageTabString {
	switch (tabNumber) {
		case eMyPurchasesPageTab.PURCHASES : {
			return eMyPurchasesPageTabString.PURCHASES;
		}
		case eMyPurchasesPageTab.QUESTIONS : {
			return eMyPurchasesPageTabString.QUESTIONS;
		}
		case eMyPurchasesPageTab.FAVORITES : {
			return eMyPurchasesPageTabString.FAVORITES;
		}
	}
}
